(function initializeNostoPdpOrigin(global) {
    "use strict";

    const url =
        new URL(
            global.location.href
        );

    const isFromNostoSearch =
        url.searchParams.get(
            "fromnostosearch"
        ) === "true";

    const isFromNostoCategory =
        url.searchParams.get(
            "fromnostocategory"
        ) === "true";

    /*
     * Un PDP normal no necesita ningún comportamiento extra.
     */
    if (
        !isFromNostoSearch &&
        !isFromNostoCategory
    ) {
        return;
    }

    document.addEventListener(
        "theme:product:add",
        async () => {
            try {
                if (
                    typeof global.Nosto
                        ?.reloadCartWithFlags !==
                    "function"
                ) {
                    console.warn(
                        "[Nosto PDP] reloadCartWithFlags no está disponible."
                    );

                    return;
                }

                await global.Nosto
                    .reloadCartWithFlags({
                        skipEvents: true,
                    });

                console.log(
                    "[Nosto PDP] Carrito recargado con flags."
                );

            } catch (error) {
                console.warn(
                    "[Nosto PDP] reloadCartWithFlags falló.",
                    error
                );
            }
        }
    );
})(window);